var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgW2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4031 22.4329C21.8681 22.4948 22.7105 22.9735 23.3873 23.3582C24.0271 23.7217 24.4893 23.9844 25.5469 23.9844C26.6045 23.9844 27.0666 23.7217 27.7064 23.3582C28.3833 22.9736 29.2257 22.4948 30.6907 22.4329L31.4286 22.4017L26.7188 13.5362V8.59375H34.9219C35.3658 8.59375 35.7716 8.34297 35.97 7.94594C36.1685 7.54898 36.1257 7.07391 35.8594 6.71875L34.043 4.29688L35.8594 1.875C36.1257 1.51992 36.1685 1.04484 35.97 0.647812C35.7716 0.250781 35.3658 0 34.9219 0H25.5469C24.8997 0 24.375 0.524687 24.375 1.17188V7.42188V13.5362L19.6652 22.4017L20.4031 22.4329Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72414 26.9238C10.228 27.2708 10.5609 27.5 11.3281 27.5C12.0953 27.5 12.4282 27.2708 12.9321 26.9238C13.4155 26.591 14.0169 26.1769 14.9619 26.0097L15.1082 25.9838L15.4803 25.2834L12.3585 19.52C12.1537 19.1418 11.7582 18.9062 11.3281 18.9062C10.898 18.9062 10.5026 19.1418 10.2977 19.52L6.86218 25.8625L7.69429 26.0097C8.63929 26.1769 9.24078 26.591 9.72414 26.9238Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3281 29.8437C9.83209 29.8437 9.03514 29.295 8.3949 28.8541C8.00865 28.5882 7.72951 28.396 7.286 28.3175L5.68568 28.0344L0.141465 38.27C-0.0552542 38.6331 -0.0462699 39.0729 0.165058 39.4278C0.376386 39.7826 0.758886 40 1.17186 40H7.66217L13.2683 29.4474C12.7754 29.6739 12.1601 29.8437 11.3281 29.8437Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8631 38.2784L32.6474 24.696L30.7897 24.7746C29.8909 24.8126 29.4602 25.0573 28.8643 25.396C28.1335 25.8113 27.2239 26.3282 25.5469 26.3282C23.8699 26.3282 22.9603 25.8113 22.2294 25.396C21.6334 25.0573 21.2028 24.8126 20.304 24.7746L18.4463 24.696L10.3161 40H38.8281C39.2395 40 39.6206 39.7844 39.8325 39.4319C40.0445 39.0794 40.056 38.6416 39.8631 38.2784Z",
    fill: "#2A323F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW2);
export default __webpack_public_path__ + "static/media/w2.96959dcd94b616cd43143a1ea69a1228.svg";
export { ForwardRef as ReactComponent };